import { motion } from "framer-motion";

const PHONE = "919866633016";
const MSG = encodeURIComponent(
  "Hi Bhaaskar Productions! I'd like to enquire about event production (LED / lighting / sound) for my event."
);

export default function WhatsAppButton() {
  return (
    <motion.a
      href={`https://wa.me/${PHONE}?text=${MSG}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="Enquire on WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.94 }}
      className="fixed bottom-6 right-6 z-[60] flex items-center gap-3 group"
    >
      <span className="hidden sm:block bg-[#050505]/90 backdrop-blur-md border border-white/10 text-white text-sm px-4 py-2 opacity-0 group-hover:opacity-100 transition-opacity">
        Chat on WhatsApp
      </span>
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-[0_8px_30px_rgba(37,211,102,0.45)]">
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-60 animate-ping" />
        <svg viewBox="0 0 32 32" className="relative h-7 w-7" fill="#050505" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.003 3C9.383 3 4 8.383 4 15.003c0 2.117.553 4.184 1.603 6.007L4 29l8.184-1.57a11.94 11.94 0 0 0 3.819.626h.001C22.62 28.056 28 22.673 28 16.053 28 12.86 26.76 9.86 24.51 7.61 22.26 5.36 19.26 4 16.003 3zm0 21.86h-.001a9.9 9.9 0 0 1-5.043-1.38l-.362-.215-3.741.718.749-3.648-.236-.375a9.86 9.86 0 0 1-1.51-5.24c0-5.46 4.443-9.902 9.907-9.902 2.646 0 5.132 1.031 7.003 2.903a9.83 9.83 0 0 1 2.9 7.003c-.002 5.462-4.446 9.909-9.907 9.909zm5.432-7.417c-.298-.149-1.762-.869-2.035-.968-.273-.099-.472-.149-.671.15-.198.297-.767.967-.94 1.166-.173.198-.347.223-.644.074-.298-.149-1.257-.463-2.395-1.477-.885-.789-1.482-1.763-1.656-2.061-.173-.298-.018-.459.13-.607.134-.133.298-.347.446-.52.15-.174.199-.298.298-.497.099-.198.05-.372-.025-.521-.074-.149-.671-1.617-.919-2.213-.242-.581-.487-.502-.671-.512l-.571-.01c-.198 0-.52.074-.792.372-.273.298-1.04 1.016-1.04 2.479 0 1.462 1.065 2.876 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.693.626.712.226 1.36.194 1.872.118.571-.085 1.762-.72 2.01-1.416.248-.695.248-1.29.173-1.416-.074-.124-.272-.198-.57-.347z" />
        </svg>
      </span>
    </motion.a>
  );
}
